import React, { useState, useEffect, useContext } from "react";

import PantallaContext from "../context/PantallaContext";
import { addsql } from "../context/PantallaReducer";
import FuncionesContext from "../context/FuncionesContext";
import { useLocation } from "react-router";

import SwitchMaestro from "../components/SwitchMaestro";

import { Card } from "reactstrap";
import HeaderConf from "../components/HeaderConf";
import ModalesContext from "../context/ModalContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleNotch } from "@fortawesome/free-solid-svg-icons";
import { useRefStore } from "../../..";
import { tryFocusWithRetry } from "../helper/funciones";

const SubPantalla = (props) => {
  let { configuracion, id, nollamar, indiceConf, modalProps, params, qsBody } =
    props;

  const [store, setStore] = useRefStore();
  const id_a = configuracion.opciones.id_a;

  const { configuraciones_padre } = store;
  const { PantallaDispatch, opciones_de_pantalla } =
    useContext(PantallaContext);

  const { getConfiguracion, requestErrorHandler } =
    useContext(FuncionesContext);
  const { getModal } = useContext(ModalesContext);

  const [loadingPantalla, setLoadingPantalla] = useState(false);

  const [subPantallaConfs, setSubPantallaConfs] = useState(configuracion);
  let { search, state: locationState = { filtros: {} } } = useLocation();

  const qs = search?.split("?")[1];

  const ref = localStorage.getItem("referrer");
  const ses = sessionStorage.getItem("referrer");
  const referrer = ref
    ? JSON.parse(localStorage.getItem("referrer"))
    : undefined;
  const session = ses
    ? JSON.parse(sessionStorage.getItem("referrer"))
    : undefined;

  if (qs) {
    const qsPairs = qs.split("&");
    qsBody = (() => {
      let resBody = {};

      qsPairs.forEach((q) => {
        const kp = q.split("=");
        if (!kp[0]) return;
        resBody[kp[0]] = kp[1];
      });
      return resBody;
    })();
  }

  if (referrer) {
    localStorage.removeItem("referrer");
    sessionStorage.setItem("referrer", JSON.stringify(referrer));

    if (referrer.filtros) {
      locationState.filtros = referrer.filtros;
    }
  }
  if (session?.filtros) {
    locationState.filtros = session.filtros;
  }

  useEffect(() => {
    if (nollamar) return;

    const refrescarEventCallback = async () => {
      setLoadingPantalla(true);

      try {

        const response = await getConfiguracion(
          id_a,
          qsBody,
          params,
          configuraciones_padre[id_a],
        );

        if (response.status >= 400) {
          requestErrorHandler(response);
          return;
        }

        PantallaDispatch({
          type: "SET_DATOS_CONF",
          payload: { configuracion: response.data, indiceConf },
        });

        // PantallaDispatch({
        //   type: "ADD_SQL",
        //   payload: response.data.sql,
        // });

        setStore({ sql: addsql(response.data?.sql, store.sql) });

        setSubPantallaConfs(response.data);
        setLoadingPantalla(false);
      } catch (error) {
        console.log(error);
      }
    };

    document.addEventListener(id_a, refrescarEventCallback);
    return () => {
      document.removeEventListener(id_a, refrescarEventCallback);
    };
  }, [id_a]);

  //configuraciones opciones orden
  useEffect(() => {
    tryFocusWithRetry(configuracion.opciones.focus_en);
  },[configuracion.opciones, configuracion.opciones.focus_en]);

  const ConfiguracionesComponentes = subPantallaConfs.configuraciones
    .sort((a, b) => a.opciones.orden - b.opciones.orden)
    .map((item, ic) => {
      return (
        <SwitchMaestro
          key={item.opciones.id_a}
          configuracion={item}
          indiceConf={indiceConf.concat(ic)}
          id={id}
          nollamar={nollamar}
          params={getModal(id_a).data}
          props={modalProps}
          qsBody={qsBody}
          opciones_de_pantalla={opciones_de_pantalla}
          modalProps={modalProps}
        />
      );
    });

  if (subPantallaConfs.opciones.display_container !== "s") {
    return <></>;
  }

  return (
    <Card
      id={id_a}
      className={`${id_a}_CONTENEDOR ${subPantallaConfs.opciones.className || ""}`.trim()}
      style={{
        display: "grid",
        gridTemplateColumns: "repeat(12, 1fr)",
        gridColumn: subPantallaConfs.opciones.gridSpan ?? "1/-1",
        border: "none",
        marginBottom: "0"
      }}
      data-component="SubPantalla"
    >
      <HeaderConf
        opciones={subPantallaConfs.opciones}
        className="configuracion_pantalla_titulo_secundario"
      />

      {loadingPantalla ? (
        <div
          style={{
            width: "80vw",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            height: "300px",
            fontSize: "16px",
            color: "#006f7a",
          }}
        >
          <FontAwesomeIcon
            icon={faCircleNotch}
            spin
            style={{ fontSize: "50px" }}
          />
          <div style={{ marginTop: "10px" }}>Cargando...</div>
        </div>
      ) : (
        <>{ConfiguracionesComponentes}</>
      )}
    </Card>
  );
};

export default SubPantalla;
